import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Shield, CheckCircle } from 'lucide-react';

export default function About() {
  const { t } = useLanguage();

  const values = [
    { key: 'innovation', icon: '💡' },
    { key: 'sovereignty', icon: '🛡️' },
    { key: 'rigor', icon: '⚖️' },
    { key: 'transparency', icon: '🔍' },
    { key: 'excellence', icon: '⭐' },
  ];

  return (
    <div className="min-h-screen bg-white pt-32">
      <section className="py-24 md:py-32" data-testid="about-hero">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
            {t('about.title')}
          </h1>
          <p className="text-base md:text-lg text-slate-600 leading-relaxed">
            {t('about.subtitle')}
          </p>
        </div>
      </section>

      <section className="py-16 bg-slate-50" data-testid="mission-section">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-block px-4 py-2 bg-sky-100 rounded-full mb-6">
                <p className="text-sm font-semibold text-sky-600 uppercase tracking-wider">
                  {t('about.mission')}
                </p>
              </div>
              <p className="text-base md:text-lg text-slate-700 leading-relaxed">
                {t('about.missionText')}
              </p>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-8">
              <Shield className="w-12 h-12 text-sky-600 mb-4" />
              <h3 className="text-2xl font-semibold text-slate-900 mb-4">
                {t('credibility.inpi')}
              </h3>
              <p className="text-base text-slate-600 mb-2">
                {t('credibility.inpiDesc')}
              </p>
              <p className="text-sm font-mono text-sky-600 font-semibold">
                {t('credibility.inpiNumber')}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16" data-testid="vision-section">
        <div className="max-w-6xl mx-auto px-6">
          <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-12 text-white">
            <div className="inline-block px-4 py-2 bg-white/10 rounded-full mb-6">
              <p className="text-sm font-semibold uppercase tracking-wider">
                {t('about.vision')}
              </p>
            </div>
            <p className="text-base md:text-lg leading-relaxed">
              {t('about.visionText')}
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" data-testid="values-section">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-semibold text-slate-900 mb-12 text-center">
            {t('about.values')}
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {values.map((value) => (
              <div 
                key={value.key}
                data-testid={`value-card-${value.key}`}
                className="bg-white border border-slate-200 rounded-2xl p-6 text-center hover:shadow-lg transition-all"
              >
                <div className="text-4xl mb-3">{value.icon}</div>
                <h3 className="text-base font-semibold text-slate-900">
                  {t(`about.${value.key}`)}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
